document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.custom-header');
  const panel = document.getElementById('drawerMenu');
  const toggles = document.querySelectorAll('.js-menu-toggle');

  if (!header || !panel || !toggles.length) return;

  // Com o menu aberto a pagina por tras fica parada, em qualquer tela: so o
  // menu rola. O jeito de segurar mora em smooth-scroll.js
  // (window.hogoPageLock), o mesmo do carrinho.
  const lockPageScroll = () => {
    if (window.hogoPageLock) window.hogoPageLock.lock();
  };

  const unlockPageScroll = () => {
    if (window.hogoPageLock) window.hogoPageLock.unlock();
  };

  // A barra de rolagem desenhada do menu (custom-header-drawer.liquid): so
  // aparece quando o menu passa da altura da tela, e o marcador acompanha.
  const scroller = panel.querySelector('.custom-header__panel-inner');
  const scrollbar = panel.querySelector('.custom-header__scrollbar');

  const updateScrollbar = () => {
    if (!scroller || !scrollbar) return;

    const visible = scroller.clientHeight;
    const total = scroller.scrollHeight;
    const overflow = total - visible > 1;
    scrollbar.hidden = !overflow;
    if (!overflow) return;

    const track = scrollbar.clientHeight;
    const thumb = scrollbar.firstElementChild;
    const thumbHeight = Math.max(24, (track * visible) / total);
    const progress = scroller.scrollTop / (total - visible);

    thumb.style.height = `${thumbHeight}px`;
    thumb.style.transform = `translateY(${(track - thumbHeight) * progress}px)`;
  };

  if (scroller) scroller.addEventListener('scroll', updateScrollbar, { passive: true });
  window.addEventListener('resize', updateScrollbar);

  const openMenu = () => {
    // Avisa o carrinho para se fechar: os dois paineis nunca ficam juntos.
    document.dispatchEvent(new CustomEvent('hogo:menu:open'));

    panel.classList.add('open');
    header.classList.add('menu-is-open');
    toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));

    // Sempre abre do topo, mesmo que tenha sido fechado rolado ate o fim.
    if (scroller) scroller.scrollTop = 0;

    lockPageScroll();
    requestAnimationFrame(updateScrollbar);
  };

  const closeMenu = () => {
    const wasOpen = header.classList.contains('menu-is-open');

    panel.classList.remove('open');
    header.classList.remove('menu-is-open');
    toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));

    // So libera a pagina se era o menu que a segurava: o carrinho, quando
    // aberto, cuida da propria trava.
    if (wasOpen && !header.classList.contains('cart-is-open')) unlockPageScroll();
  };

  document.addEventListener('hogo:cart:open', closeMenu);

  const isOpen = () => header.classList.contains('menu-is-open');

  toggles.forEach((btn) => {
    btn.addEventListener('click', () => (isOpen() ? closeMenu() : openMenu()));
  });

  document.querySelectorAll('.js-menu-close').forEach((el) => {
    el.addEventListener('click', closeMenu);
  });

  panel.addEventListener('click', (e) => {
    if (e.target.closest('a')) closeMenu();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) {
      closeMenu();
      toggles[toggles.length - 1].focus();
    }
  });

  document.addEventListener('click', (e) => {
    if (!isOpen()) return;
    if (e.target.closest('.custom-header')) return;
    closeMenu();
  });

  // Fecha so quando a largura muda de fato (troca de breakpoint, rotacao).
  // No celular, esconder a barra de endereco dispara resize com a mesma
  // largura, e o menu fechava sozinho na cara do cliente.
  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    if (isOpen()) closeMenu();
  });
});
